import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["id", "name", "type", "placeholder", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "text-xs leading-loose text-danger-500 mt-0.5"
}

import IconSearch from '../icons/IconSearch.vue';

// Props with default values

export default /*@__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: /*@__PURE__*/_mergeModels({
    placeholder: { default: '' },
    type: { default: 'text' },
    name: { default: '' },
    errorMsg: { default: '' },
    isSearch: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



// Define returned value
const value = _useModel<string | number>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass([
                    'w-full rounded-lg text-base leading-base px-3.5 md:px-4 py-1.5 md:py-2 transition-colors border-neutral-500 hover:border-primary-500  focus:border-primary-500 placeholder:text-base-200 focus:shadow-none',
                    _ctx.errorMsg && '!border-danger-500',
                    _ctx.isSearch && 'pl-9 md:pl-9',
                    _ctx.disabled && 'bg-neutral-50 text-base-100 hover:border-neutral-500',
                ]),
        id: _ctx.name,
        name: _ctx.name,
        type: _ctx.type,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
      }, null, 10, _hoisted_3), [
        [
          _vModelDynamic,
          value.value,
          void 0,
          { lazy: true }
        ]
      ]),
      (_ctx.isSearch)
        ? (_openBlock(), _createBlock(IconSearch, {
            key: 0,
            class: "absolute top-3 left-3 text-base-200"
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.errorMsg)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.errorMsg), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})